import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Button, TextLink } from './styles';

function LinkButton({
  children,
  path,
  onClick,
  shouldBeDisabled,
  underline = true,
}) {
  const history = useHistory();

  const onExternalClick = () => {
    history.push(path);
  };

  return (
    <Button onClick={onClick || onExternalClick} disabled={shouldBeDisabled}>
      <TextLink underline={underline} disabled={shouldBeDisabled}>
        {children}
      </TextLink>
    </Button>
  );
}

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    state: PropTypes.shape({
      step: PropTypes.number.isRequired,
    }),
  }),
  onClick: PropTypes.func,
  shouldBeDisabled: PropTypes.bool,
  underline: PropTypes.bool,
};

LinkButton.defaultProps = {
  path: {
    pathname: '/',
    state: {
      step: 1,
    },
  },
  onClick: null,
  shouldBeDisabled: false,
  underline: true,
};

export default LinkButton;
